import { createPushModal } from 'pushmodal';
import { AccountingDoctorAttending } from './accounting-doctor-attending/page';
import { AccountingRetrocessionFee } from './accounting-retrocession-fee/page';

export const {
  pushModal: pushTemplate,
  popModal: popTemplate,
  popAllModals: popAllTemplates,
  replaceWithModal: replaceWithTemplate,
  useOnPushModal: useOnPushTemplate,
  onPushModal: onPushTemplate,
  ModalProvider: TemplateProvider,
} = createPushModal({
  modals: {
    AccountingRetrocessionFee,
    AccountingDoctorAttending,
  },
});
export type TemplateNames = Parameters<typeof popTemplate>[0];
